var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "messageList", staticClass: "chat-message-list" },
    [
      _vm._l(_vm.messages, function(msg, index) {
        return _c("VueChatMessage", { key: index, attrs: { message: msg } })
      }),
      _vm.isLoading
        ? _c("VueChatMessage", { attrs: { message: _vm.loadingMessage } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }